"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialCoopDisclaimer = exports.isCartItemsEqual = exports.isEventsEqual = exports.isEventEqual = exports.isProductsEqual = exports.isProductEqual = exports.getCartItemsByMediaId = exports.setCoopTotalForCartV2 = exports.getCartItemById = exports.getCartItemId = exports.getCartItemCoopUsedPercentageText = exports.getCartItemReimbursmentRateText = exports.getCartItemCoopUsedActualPercentageText = exports.getCartItemCoopUsedActualPercentage = exports.getCartItemTotalAfterCoop = exports.getCartItemReimbursmentRate = exports.getCartItemCoopUsed = exports.getCartItemTotal = exports.getCartItemMediaId = exports.getCartItemEvent = exports.getCartItemProduct = exports.saveCartItems = exports.isEmpty = exports.getUnitedAPIItemsFromCart = exports.processUnitedAPIOrderV2 = exports.processUnitedAPIOrder = exports.getSubtotalAfterCoop = exports.getCoopUsedTotalForCartActualPercentageText = exports.getCoopUsedTotalForCartActualPercentage = exports.getCoopUsedTotalForCart = exports.getCoopUsedTotalForEvents = exports.getCoopUsedTotalForProducts = exports.getCoopUsedTotalForItems = exports.getCoopTotalForCartV2 = exports.getCoopTotalForCart = exports.getEventPrice = exports.getProductPrice = exports.getCoopAmountsForCart = exports.getCoopPercentagesForCart = exports.getMediaIds = exports.getCoopPercentages = exports.getVendorIdFromVendorType = exports.getEventSubtotal = exports.getProductSubtotal = exports.getSubtotal = exports.hasCustomProducts = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@monorepo/interfaces");
var __1 = require("..");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var cloneDeep_1 = (0, tslib_1.__importDefault)(require("lodash/cloneDeep"));
var keycloak_1 = require("../infra/keycloak");
var hasCustomProducts = function (products) {
    return products.some(function (productItem) { return productItem.product.type !== 1; });
};
exports.hasCustomProducts = hasCustomProducts;
var getSubtotal = function (items) {
    var subTotal = 0;
    subTotal += (0, exports.getProductSubtotal)(items.products);
    subTotal += (0, exports.getEventSubtotal)(items.events);
    return subTotal;
};
exports.getSubtotal = getSubtotal;
var getProductSubtotal = function (products) {
    var subTotal = 0;
    for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
        var productItem = products_1[_i];
        subTotal += (0, exports.getProductPrice)(productItem);
    }
    return subTotal;
};
exports.getProductSubtotal = getProductSubtotal;
var getEventSubtotal = function (events) {
    var subTotal = 0;
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var eventItem = events_1[_i];
        subTotal += (0, exports.getEventPrice)(eventItem);
    }
    return subTotal;
};
exports.getEventSubtotal = getEventSubtotal;
var getVendorIdFromVendorType = function (vendorType) {
    switch (vendorType) {
        case interfaces_1.Vendor.PURE:
            return 26582;
        case interfaces_1.Vendor.DSI:
            return 26577;
    }
};
exports.getVendorIdFromVendorType = getVendorIdFromVendorType;
var getAuthorizedConfig = function (config) {
    var _a;
    if (config === void 0) { config = {}; }
    var token = __1.KeycloakHelper.getToken(keycloak_1.keycloakClient);
    if (!token) {
        console.log('[CartHelper] Authorization header missing');
        return config;
    }
    var headers = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, ((_a = config.headers) !== null && _a !== void 0 ? _a : {})), { Authorization: "Bearer ".concat(token) });
    console.log('[CartHelper] Authorization header', headers.Authorization);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, config), { headers: headers });
};
var getCoopPercentageForMediaId = function (masterDealerId, mediaId, vendorType) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var vendorId, invoiceAmount, data, e_1;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                vendorId = (0, exports.getVendorIdFromVendorType)(vendorType);
                invoiceAmount = 1;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get("".concat(process.env.REACT_APP_TX_BASE_URL, "/ACB/PreCommitment/").concat(masterDealerId, "/").concat(vendorId, "/").concat(invoiceAmount, "/").concat(mediaId), getAuthorizedConfig())];
            case 2:
                data = (_a.sent()).data;
                if (data && data.ErrorOccured) {
                    console.log(data);
                }
                return [2 /*return*/, data && !data.ErrorOccured && !!data.ReimbursementRate
                        ? parseFloat(data.ReimbursementRate)
                        : 0];
            case 3:
                e_1 = _a.sent();
                console.log("error: ".concat(JSON.stringify(e_1)));
                return [2 /*return*/, 0];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getCoopPercentages = function (masterDealerId, productMediaIds, eventMediaIds) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var mediaIdPercentages, _i, productMediaIds_1, mediaId, _a, _b, _c, eventMediaIds_1, mediaId, _d, _e;
    return (0, tslib_1.__generator)(this, function (_f) {
        switch (_f.label) {
            case 0:
                mediaIdPercentages = {};
                _i = 0, productMediaIds_1 = productMediaIds;
                _f.label = 1;
            case 1:
                if (!(_i < productMediaIds_1.length)) return [3 /*break*/, 4];
                mediaId = productMediaIds_1[_i];
                _a = mediaIdPercentages;
                _b = mediaId;
                return [4 /*yield*/, getCoopPercentageForMediaId(masterDealerId, mediaId, interfaces_1.Vendor.PURE)];
            case 2:
                _a[_b] = _f.sent();
                _f.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4:
                _c = 0, eventMediaIds_1 = eventMediaIds;
                _f.label = 5;
            case 5:
                if (!(_c < eventMediaIds_1.length)) return [3 /*break*/, 8];
                mediaId = eventMediaIds_1[_c];
                _d = mediaIdPercentages;
                _e = mediaId;
                return [4 /*yield*/, getCoopPercentageForMediaId(masterDealerId, mediaId, interfaces_1.Vendor.DSI)];
            case 6:
                _d[_e] = _f.sent();
                _f.label = 7;
            case 7:
                _c++;
                return [3 /*break*/, 5];
            case 8: return [2 /*return*/, mediaIdPercentages];
        }
    });
}); };
exports.getCoopPercentages = getCoopPercentages;
var getMediaIds = function (items) {
    var productMediaIds = Array.isArray(items.products)
        ? (0, tslib_1.__spreadArray)([], Array.from(new Set(items.products.map(function (item) { return item.product.mediaIdACB; }))), true) : [];
    var eventMediaIds = Array.isArray(items.events)
        ? (0, tslib_1.__spreadArray)([], Array.from(new Set(items.events.map(function (item) { return item.event.mediaIdACB; }))), true) : [];
    return { productMediaIds: productMediaIds, eventMediaIds: eventMediaIds };
};
exports.getMediaIds = getMediaIds;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCoopPercentagesForCart = function (items, coopPercentages) {
    var result = {};
    if (!items || !coopPercentages) {
        return result;
    }
    if (Array.isArray(items.products)) {
        items.products.forEach(function (item) {
            if (coopPercentages[item.product.mediaIdACB]) {
                result[item.product._id] =
                    coopPercentages[item.product.mediaIdACB];
            }
        });
    }
    if (Array.isArray(items.events)) {
        items.events.forEach(function (item) {
            if (coopPercentages[item.event.mediaIdACB]) {
                result[item.event._id] =
                    coopPercentages[item.event.mediaIdACB];
            }
        });
    }
    return result;
};
exports.getCoopPercentagesForCart = getCoopPercentagesForCart;
var getCoopAmountsForCart = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var _a, productMediaIds, eventMediaIds, mediaIdPercentages, result, _i, _b, productItem, product, productPrice, _c, _d, eventItem, event_1, eventPrice;
    return (0, tslib_1.__generator)(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = (0, exports.getMediaIds)(items), productMediaIds = _a.productMediaIds, eventMediaIds = _a.eventMediaIds;
                return [4 /*yield*/, (0, exports.getCoopPercentages)(masterDealerId, productMediaIds, eventMediaIds)];
            case 1:
                mediaIdPercentages = _e.sent();
                result = {};
                for (_i = 0, _b = items.products; _i < _b.length; _i++) {
                    productItem = _b[_i];
                    product = productItem.product;
                    productPrice = (0, exports.getProductPrice)(productItem);
                    if (productPrice > 0.0) {
                        result[productItem.product._id] = {
                            amount: (0, __1.roundCurrency)(productPrice * mediaIdPercentages[product.mediaIdACB]),
                            percentage: mediaIdPercentages[product.mediaIdACB],
                        };
                    }
                }
                for (_c = 0, _d = items.events; _c < _d.length; _c++) {
                    eventItem = _d[_c];
                    event_1 = eventItem.event;
                    eventPrice = (0, exports.getEventPrice)(eventItem);
                    if (eventPrice > 0.0) {
                        result[eventItem.event._id] = {
                            amount: (0, __1.roundCurrency)(eventPrice * mediaIdPercentages[event_1.mediaIdACB]),
                            percentage: mediaIdPercentages[event_1.mediaIdACB],
                        };
                    }
                }
                return [2 /*return*/, result];
        }
    });
}); };
exports.getCoopAmountsForCart = getCoopAmountsForCart;
var getProductPrice = function (cartProduct) {
    var _a, _b;
    var product = cartProduct.product, selectedDeliveryMethodIndex = cartProduct.selectedDeliveryMethodIndex, selectedVariantIndex = cartProduct.selectedVariantIndex, selectedPrintAndShipIndex = cartProduct.selectedPrintAndShipIndex;
    if (product.type === interfaces_1.ProductType.MICROSITE) {
        return (0, __1.roundCurrency)(parseFloat(product.variants[selectedVariantIndex].printAndShipOptions[0].price) * cartProduct.quantity);
    }
    if (product.type === interfaces_1.ProductType.CREATIVE_CUSTOM) {
        return (0, __1.roundCurrency)(parseFloat((_a = product.variants[selectedVariantIndex].printAndShipOptions[0]) === null || _a === void 0 ? void 0 : _a.price) * cartProduct.quantity);
    }
    if (selectedDeliveryMethodIndex === interfaces_1.DeliveryMethod.DOWNLOAD ||
        selectedDeliveryMethodIndex === interfaces_1.DeliveryMethod.PLACE_WITH_AGENCY) {
        return 0.0;
    }
    if (selectedDeliveryMethodIndex === interfaces_1.DeliveryMethod.CUSTOM_QUOTE) {
        if (product.type !== interfaces_1.ProductType.CREATIVE_CUSTOM) {
            return 0.0;
        }
    }
    return (0, __1.roundCurrency)(parseFloat((_b = product.variants[selectedVariantIndex].printAndShipOptions[selectedPrintAndShipIndex]) === null || _b === void 0 ? void 0 : _b.price) * cartProduct.quantity);
};
exports.getProductPrice = getProductPrice;
var getEventPrice = function (cartEvent) {
    var event = cartEvent.event;
    return (0, __1.roundCurrency)(parseFloat(event.price) * cartEvent.quantity);
};
exports.getEventPrice = getEventPrice;
var getCoopTotalForCart = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var unitedItems, data, e_2;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                unitedItems = (0, exports.getUnitedAPIItemsFromCart)(items);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessPreCommitment"), { Items: unitedItems, MasterDealerId: masterDealerId }, getAuthorizedConfig())];
            case 2:
                data = (_a.sent()).data;
                if (data.ErrorOccured) {
                    return [2 /*return*/, 0];
                }
                return [2 /*return*/, (0, __1.roundCurrency)(parseFloat(data.TotalAmount))];
            case 3:
                e_2 = _a.sent();
                console.log("error: ".concat(JSON.stringify(e_2)));
                return [2 /*return*/, 0];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getCoopTotalForCart = getCoopTotalForCart;
var getCoopTotalForCartV2 = function (masterDealerId, items) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var _items, unitedItems, data, e_3;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _items = (0, cloneDeep_1.default)(items);
                unitedItems = (0, exports.getUnitedAPIItemsFromCart)(_items);
                if (!unitedItems.length) {
                    return [2 /*return*/, _items];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessPreCommitmentV2"), { Items: unitedItems, MasterDealerId: masterDealerId }, getAuthorizedConfig())];
            case 2:
                data = (_a.sent()).data;
                if (data.ErrorOccured) {
                    return [2 /*return*/, _items];
                }
                return [2 /*return*/, (0, exports.setCoopTotalForCartV2)(_items, data)];
            case 3:
                e_3 = _a.sent();
                console.log("error: ".concat(JSON.stringify(e_3)));
                return [2 /*return*/, _items];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getCoopTotalForCartV2 = getCoopTotalForCartV2;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCoopUsedTotalForItems = function (items) {
    return Array.isArray(items)
        ? items.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (accumulator, currentValue) {
            return !isNaN((0, exports.getCartItemCoopUsed)(currentValue))
                ? (0, __1.roundCurrency)(accumulator + ((0, exports.getCartItemCoopUsed)(currentValue) || 0.0))
                : accumulator;
        }, 0.0)
        : 0.0;
};
exports.getCoopUsedTotalForItems = getCoopUsedTotalForItems;
var getCoopUsedTotalForProducts = function (items) {
    return (0, exports.getCoopUsedTotalForItems)(items === null || items === void 0 ? void 0 : items.products);
};
exports.getCoopUsedTotalForProducts = getCoopUsedTotalForProducts;
var getCoopUsedTotalForEvents = function (items) {
    return (0, exports.getCoopUsedTotalForItems)(items === null || items === void 0 ? void 0 : items.events);
};
exports.getCoopUsedTotalForEvents = getCoopUsedTotalForEvents;
var getCoopUsedTotalForCart = function (items) {
    return (0, __1.roundCurrency)((0, exports.getCoopUsedTotalForProducts)(items) + (0, exports.getCoopUsedTotalForEvents)(items));
};
exports.getCoopUsedTotalForCart = getCoopUsedTotalForCart;
var getCoopUsedTotalForCartActualPercentage = function (items) {
    var total = (0, exports.getSubtotal)(items);
    return total > 0 ? (0, exports.getCoopUsedTotalForCart)(items) / total : 0.0;
};
exports.getCoopUsedTotalForCartActualPercentage = getCoopUsedTotalForCartActualPercentage;
var getCoopUsedTotalForCartActualPercentageText = function (items) {
    var result = (0, exports.getCoopUsedTotalForCartActualPercentage)(items) * 100;
    return result > 0 ? "".concat(result.toFixed(0), "%") : undefined;
};
exports.getCoopUsedTotalForCartActualPercentageText = getCoopUsedTotalForCartActualPercentageText;
var getSubtotalAfterCoop = function (items) {
    return (0, __1.roundCurrency)(((0, exports.getSubtotal)(items) || 0.0) - ((0, exports.getCoopUsedTotalForCart)(items) || 0.0));
};
exports.getSubtotalAfterCoop = getSubtotalAfterCoop;
var processUnitedAPIOrder = function (orderNumber, email, masterDealerId, items, context) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var unitedItems;
    return (0, tslib_1.__generator)(this, function (_a) {
        unitedItems = (0, exports.getUnitedAPIItemsFromCart)(items, orderNumber, context.isUsingCoop);
        return [2 /*return*/, new Promise(function (resolve, reject) {
                axios_1.default
                    .post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessOrder"), {
                    Items: unitedItems,
                    MasterDealerId: masterDealerId,
                    UPN: email,
                    CardNumber: context.cardNumber,
                    ExpirationMonth: Number(context.expirationMonth),
                    ExpirationYear: Number(context.expirationYear),
                    CCV: context.CCV,
                    FirstName: context.billingAddress.firstName,
                    LastName: context.billingAddress.lastName,
                    AddressLine: context.billingAddress.address1,
                    City: context.billingAddress.city,
                    State: context.billingAddress.state,
                    ZipCode: context.billingAddress.zipCode,
                    Description: "Order #".concat(orderNumber),
                    OrderId: orderNumber,
                }, getAuthorizedConfig())
                    .then(function (_a) {
                    var processOrderResponse = _a.data;
                    if (processOrderResponse.ErrorOccured) {
                        reject([
                            processOrderResponse.ErrorDescription,
                            processOrderResponse.ErrorTransactionDescription,
                        ]);
                    }
                    var payments = [];
                    for (var _i = 0, _b = processOrderResponse.Payments; _i < _b.length; _i++) {
                        var paymentItem = _b[_i];
                        payments.push({
                            id: paymentItem.Id,
                            amount: paymentItem.Amount.toString(),
                            type: paymentItem.PaymentType,
                            date: new Date(paymentItem.date).toUTCString(),
                        });
                    }
                    resolve(payments);
                });
            })];
    });
}); };
exports.processUnitedAPIOrder = processUnitedAPIOrder;
var processUnitedAPIOrderV2 = function (orderNumber, email, masterDealerId, items, context) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var unitedItems;
    return (0, tslib_1.__generator)(this, function (_a) {
        unitedItems = (0, exports.getUnitedAPIItemsFromCart)(items, orderNumber, context.isUsingCoop);
        return [2 /*return*/, new Promise(function (resolve, reject) {
                axios_1.default
                    .post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/ProcessOrderV2"), {
                    Items: unitedItems,
                    MasterDealerId: masterDealerId,
                    UPN: email,
                    CardNumber: context.cardNumber,
                    ExpirationMonth: Number(context.expirationMonth),
                    ExpirationYear: Number(context.expirationYear),
                    CCV: context.CCV,
                    FirstName: context.billingAddress.firstName,
                    LastName: context.billingAddress.lastName,
                    AddressLine: context.billingAddress.address1,
                    City: context.billingAddress.city,
                    State: context.billingAddress.state,
                    ZipCode: context.billingAddress.zipCode,
                    Description: "Order #".concat(orderNumber),
                    OrderId: orderNumber,
                }, getAuthorizedConfig())
                    .then(function (_a) {
                    var processOrderResponse = _a.data;
                    if (processOrderResponse.ErrorOccured) {
                        reject([
                            processOrderResponse.ErrorDescription,
                            processOrderResponse.ErrorTransactionDescription,
                        ]);
                    }
                    var payments = [];
                    for (var _i = 0, _b = processOrderResponse.Payments; _i < _b.length; _i++) {
                        var paymentItem = _b[_i];
                        payments.push({
                            id: paymentItem.Id,
                            amount: paymentItem.Amount.toString(),
                            type: paymentItem.PaymentType,
                            date: new Date(paymentItem.date).toUTCString(),
                        });
                    }
                    resolve(payments);
                });
            })];
    });
}); };
exports.processUnitedAPIOrderV2 = processUnitedAPIOrderV2;
var getUnitedAPIItemsFromCart = function (items, invoiceNumber, isUsingCoop) {
    if (invoiceNumber === void 0) { invoiceNumber = 0; }
    if (isUsingCoop === void 0) { isUsingCoop = true; }
    var orderItems = [];
    items.products.forEach(function (productItem, i) {
        var orderItem = {
            ApplyCoop: isUsingCoop,
            InvoiceAmount: (0, exports.getProductPrice)(productItem),
            MediaId: productItem.product.mediaIdACB,
            VendorId: (0, exports.getVendorIdFromVendorType)(interfaces_1.Vendor.PURE),
            PlanDescription: productItem.product.title,
            IsEvent: false,
        };
        if (invoiceNumber !== 0) {
            orderItem.InvoiceNumber = "".concat(invoiceNumber, ".creative.").concat(i);
        }
        orderItems.push(orderItem);
    });
    items.events.forEach(function (eventItem, i) {
        var orderItem = {
            ApplyCoop: isUsingCoop,
            InvoiceAmount: (0, exports.getEventPrice)(eventItem),
            MediaId: eventItem.event.mediaIdACB,
            VendorId: (0, exports.getVendorIdFromVendorType)(interfaces_1.Vendor.DSI),
            PlanDescription: eventItem.event.title,
            IsEvent: true,
        };
        if (invoiceNumber !== 0) {
            orderItem.InvoiceNumber = "".concat(invoiceNumber, ".event.").concat(i);
        }
        orderItems.push(orderItem);
    });
    return orderItems;
};
exports.getUnitedAPIItemsFromCart = getUnitedAPIItemsFromCart;
var isEmpty = function (items) {
    return (!Array.isArray(items === null || items === void 0 ? void 0 : items.products) || !items.products.length) &&
        (!Array.isArray(items === null || items === void 0 ? void 0 : items.events) || !items.events.length);
};
exports.isEmpty = isEmpty;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var saveCartItems = function (order) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __1.http.post({ url: '/order', data: order })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.saveCartItems = saveCartItems;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemProduct = function (item) { return item.product; };
exports.getCartItemProduct = getCartItemProduct;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemEvent = function (item) { return item.event; };
exports.getCartItemEvent = getCartItemEvent;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemMediaId = function (item) {
    return (0, exports.getCartItemProduct)(item)
        ? item.product.mediaIdACB
        : (0, exports.getCartItemEvent)(item)
            ? item.event.mediaIdACB
            : undefined;
};
exports.getCartItemMediaId = getCartItemMediaId;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemTotal = function (item) {
    return (0, exports.getCartItemProduct)(item)
        ? (0, exports.getProductPrice)(item)
        : (0, exports.getCartItemEvent)(item)
            ? (0, exports.getEventPrice)(item)
            : 0.0;
};
exports.getCartItemTotal = getCartItemTotal;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemCoopUsed = function (item) { return item.coopUsed || 0.0; };
exports.getCartItemCoopUsed = getCartItemCoopUsed;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemReimbursmentRate = function (item) {
    return item.reimbursmentRate || 0.0;
};
exports.getCartItemReimbursmentRate = getCartItemReimbursmentRate;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemTotalAfterCoop = function (item) {
    return (0, __1.roundCurrency)((0, exports.getCartItemTotal)(item) - (0, exports.getCartItemCoopUsed)(item));
};
exports.getCartItemTotalAfterCoop = getCartItemTotalAfterCoop;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemCoopUsedActualPercentage = function (item) {
    var total = (0, exports.getCartItemTotal)(item);
    return total > 0 ? (0, exports.getCartItemCoopUsed)(item) / total : 0.0;
};
exports.getCartItemCoopUsedActualPercentage = getCartItemCoopUsedActualPercentage;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemCoopUsedActualPercentageText = function (item) {
    var result = (0, exports.getCartItemCoopUsedActualPercentage)(item) * 100;
    return result > 0 ? "".concat(result.toFixed(0), "%") : undefined;
};
exports.getCartItemCoopUsedActualPercentageText = getCartItemCoopUsedActualPercentageText;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemReimbursmentRateText = function (item) {
    var result = (0, exports.getCartItemReimbursmentRate)(item) * 100;
    return result > 0 ? "".concat(result.toFixed(0), "%") : undefined;
};
exports.getCartItemReimbursmentRateText = getCartItemReimbursmentRateText;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemCoopUsedPercentageText = function (item) {
    var reimbursmentRateText = (0, exports.getCartItemReimbursmentRateText)(item);
    var actualPercentageText = (0, exports.getCartItemCoopUsedActualPercentageText)(item);
    return "".concat(!!reimbursmentRateText ? reimbursmentRateText : '').concat(!reimbursmentRateText ||
        (!!actualPercentageText && reimbursmentRateText !== actualPercentageText)
        ? "".concat(!!reimbursmentRateText ? ' (' : '').concat(actualPercentageText).concat(!!reimbursmentRateText ? ')' : '')
        : '');
};
exports.getCartItemCoopUsedPercentageText = getCartItemCoopUsedPercentageText;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemId = function (item) {
    return (0, exports.getCartItemProduct)(item)
        ? item.product._id
        : (0, exports.getCartItemEvent)(item)
            ? item.event._id
            : undefined;
};
exports.getCartItemId = getCartItemId;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getCartItemById = function (items, id) {
    return items.products.find(function (item) { return item.product._id === id; }) ||
        items.events.find(function (item) { return item.event._id === id; });
};
exports.getCartItemById = getCartItemById;
var setCoopTotalForCartV2 = function (items, data) {
    if (!items || !data || !Array.isArray(data.MediaItems)) {
        return items;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sortFn = function (left, right) {
        return (0, exports.getCartItemTotal)(right) - (0, exports.getCartItemTotal)(left);
    };
    var itemsByMediaId = (0, exports.getCartItemsByMediaId)(items);
    for (var i = 0, l = data.MediaItems.length; i < l; ++i) {
        var mediaItem = data.MediaItems[i];
        if (!mediaItem.ApplyCoop ||
            !mediaItem.InvoiceAmount ||
            !itemsByMediaId[mediaItem.MediaId]) {
            continue;
        }
        var tmpItemsByMediaId = itemsByMediaId[mediaItem.MediaId].sort(sortFn);
        var currentCoop = (0, __1.roundCurrency)(mediaItem.CommitmentAmount);
        for (var _i_ = 0, _l_ = tmpItemsByMediaId.length; currentCoop > 0 && _i_ < _l_; ++_i_) {
            var tmpItem = tmpItemsByMediaId[_i_];
            var tmpItemId = (0, exports.getCartItemId)(tmpItem);
            var item = void 0;
            if (!tmpItemId || !(item = (0, exports.getCartItemById)(items, tmpItemId))) {
                continue;
            }
            var itemCoop = (0, __1.roundCurrency)((0, exports.getCartItemTotal)(item) * mediaItem.ReimbursmentRate);
            if (itemCoop > currentCoop) {
                itemCoop = currentCoop;
            }
            item.coopUsed = itemCoop;
            item.reimbursmentRate = mediaItem.ReimbursmentRate;
            currentCoop -= itemCoop;
        }
    }
    items.notEnoughCoop = data.NotEnoughCoop;
    return items;
};
exports.setCoopTotalForCartV2 = setCoopTotalForCartV2;
var getCartItemsByMediaId = function (items) {
    if (!items) {
        return items;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var callbackFn = function (accumulator, currentValue) {
        var mediaId = (0, exports.getCartItemMediaId)(currentValue);
        if (!accumulator[mediaId]) {
            accumulator[mediaId] = [];
        }
        accumulator[mediaId].push(currentValue);
        return accumulator;
    };
    return items.events.reduce(callbackFn, items.products.reduce(callbackFn, {}));
};
exports.getCartItemsByMediaId = getCartItemsByMediaId;
var isProductEqual = function (left, right) {
    return left &&
        right &&
        left.product &&
        right.product &&
        left.product._id === right.product._id &&
        left.selectedVariantIndex === right.selectedVariantIndex &&
        left.selectedDeliveryMethodIndex === right.selectedDeliveryMethodIndex &&
        left.selectedPrintAndShipIndex === right.selectedPrintAndShipIndex &&
        left.quantity === right.quantity;
};
exports.isProductEqual = isProductEqual;
var isProductsEqual = function (left, right) { return (0, __1.isArrayEqual)(left, right, exports.isProductEqual); };
exports.isProductsEqual = isProductsEqual;
var isEventEqual = function (left, right) {
    return left &&
        right &&
        left.event &&
        right.event &&
        left.event._id === right.event._id &&
        left.quantity === right.quantity;
};
exports.isEventEqual = isEventEqual;
var isEventsEqual = function (left, right) { return (0, __1.isArrayEqual)(left, right, exports.isEventEqual); };
exports.isEventsEqual = isEventsEqual;
var isCartItemsEqual = function (left, right) {
    return left &&
        right &&
        (left === right ||
            ((0, exports.isProductsEqual)(left.products, right.products) &&
                (0, exports.isEventsEqual)(left.events, right.events)));
};
exports.isCartItemsEqual = isCartItemsEqual;
exports.partialCoopDisclaimer = 'Your available Co-Op balance has been applied. Any remaining amount will be charged to your credit card.';
